import { useState, useRef, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ArtistProfileAboutTab from "./Tab/ArtistProfileAboutTab";
import ArtistProfileShowsTab from "./Tab/ArtistProfileShowsTab";
import ArtistProfileMusicSetupTab from "./Tab/ArtistProfileMusicSetupTab";
import BuyTicketModal from "../Modal/BuyTicketModal";
import { useBuy } from "@/context/buy";
import { useMusic } from "@/context/music";
import { useRouter } from "next/router";

export default function ArtistProfileTabView({
  artist,
  info,
  showsListing = [],
  ref,
  setSelection,
  tracks = [],
}) {
  const { openSingleModal, openModal, selectedData, setSelectedData } =
    useBuy();
  const { targetTab, setTargetTab } = useMusic();
  const [selectedTab, setSelectedTab] = useState(
    selectedData ? "shows" : "about"
  );
  const router = useRouter();
  const aboutRef = useRef(null);
  const showsRef = useRef(null);
  const musicSetupRef = useRef(null);
  const [showData, setShowData] = useState([]);
  const [indicatorProps, setIndicatorProps] = useState({ left: 0, width: 0 });
  const data = info.data;

  useEffect(() => {
    if (targetTab === "musicSetup") {
      setSelectedTab("musicSetup");
      setTargetTab(null);
    }
  }, [targetTab, setTargetTab]);

  useEffect(() => {
    const activeRef =
      selectedTab === "about"
        ? aboutRef
        : selectedTab === "shows"
        ? showsRef
        : musicSetupRef;
    if (activeRef.current) {
      setIndicatorProps({
        left: activeRef.current.offsetLeft,
        width: activeRef.current.offsetWidth,
      });
    }
    if (selectedTab == "shows") {
      setSelection(true);
    } else {
      setSelection(false);
    }
  }, [selectedTab]);

  return (
    <div className="lg:pl-[153px] px-6 lg:pr-[197px]">
      {openModal.buy &&
        showData &&
        showData.length > 0 && (
          <AnimatePresence>
            <div className="absolute">
              <BuyTicketModal
                showData={selectedData}
                currentArtist={info?.data?.id}
              />
            </div>
          </AnimatePresence>
        )}
      <div className="lg:mt-[37px] lg:py-[32px]">
        <div className="relative flex justify-center items-center lg:gap-[60px] pb-[6px]">
          <span className="absolute w-full h-[1px] lg:h-[3px] bg-[#222222] bottom-[1px] z-[-1]"></span>
          <motion.span
            layout
            transition={{ type: "spring", stiffness: 500, damping: 30 }}
            className="absolute h-[2px] lg:h-[5px] bg-white bottom-0"
            style={{ left: indicatorProps.left, width: indicatorProps.width }}
          />
          <p
            ref={aboutRef}
            onClick={() => setSelectedTab("about")}
            className="mb-0 pb-[8px] w-full lg:w-fit text-center cursor-pointer lg:text-[26px] font-[700] lg:leading-[26px] lg:px-[33px]"
          >
            About
          </p>
          <p
            ref={showsRef}
            onClick={() => setSelectedTab("shows")}
            className="mb-0 pb-[8px] w-full lg:w-fit text-center cursor-pointer lg:text-[26px] font-[700] lg:leading-[26px] lg:px-[33px]"
          >
            Shows
          </p>
          <p
            ref={musicSetupRef}
            onClick={() => setSelectedTab("musicSetup")}
            className="mb-0 pb-[8px] w-full lg:w-fit text-center cursor-pointer lg:text-[26px] font-[700] lg:leading-[26px] lg:px-[33px]"
          >
            Music
          </p>
        </div>
      </div>
      <div className="">
        {selectedTab === "about" ? (
          <ArtistProfileAboutTab content={data?.bio} />
        ) : selectedTab === "shows" ? (
          <ArtistProfileShowsTab
            ref={ref}
            selectedShow={selectedData}
            setSelectedShow={setSelectedData}
            artist={info?.data}
            showData={showData}
            setShowData={setShowData}
          />
        ) : selectedTab === "musicSetup" ? (
          <ArtistProfileMusicSetupTab
            artist={info?.data}
            tracks={tracks.data}
            artistPageUrl={router.asPath}
          />
        ) : null}
      </div>
    </div>
  );
}
